import Card from "@/components/card"
import { useRisksSpace } from "@/core/risks-space.context"
import DashboardCardTitle from "./DashboardCardTitle"
import UnitChip from "@/components/UnitChip"
import { useAppSelector } from "@/core/root-reducer"
import populationStore from "@/entities/population/model/population.store"
import RpsRiskCell, { RPS_GLOBAL_CELL_WIDTH } from "@/entities/population/ui/RpsRiskCell"
import { faHeart } from "@fortawesome/free-solid-svg-icons"
import { useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

const POPULATION_HEIGHT = 36
const POPULATION_GAP = 10

export default function EstablishmentRpsOverview({ fillHeight = false }: { fillHeight?: boolean }) {
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()
  const populationsContainerRef = useRef<HTMLDivElement>(null)
  const [availablePopulationCount, setAvailablePopulationCount] = useState(0)
  const populations = useAppSelector(populationStore.selectors.listForActiveEstablishment)

  //Fonctions evaluees, de la plus exposee a la moins exposee
  const concernedPopulations = useMemo(
    () =>
      populations
        .filter((population) => population.cRpsLevel !== null)
        .sort((first, second) => (second.cRpsLevel ?? -1) - (first.cRpsLevel ?? -1)),
    [populations]
  )
  const openMatrix = () => navigate(getPath("/rps"))
  const hasRisk = concernedPopulations.length > 0

  //Autant de fonctions que la hauteur de la carte le permet
  useEffect(() => {
    const container = populationsContainerRef.current
    if (!container) return

    const updateAvailablePopulationCount = () => {
      const count = Math.floor((container.clientHeight + POPULATION_GAP) / (POPULATION_HEIGHT + POPULATION_GAP))
      setAvailablePopulationCount(Math.max(1, count))
    }

    updateAvailablePopulationCount()
    const observer = new ResizeObserver(updateAvailablePopulationCount)
    observer.observe(container)
    return () => observer.disconnect()
  }, [hasRisk])

  return (
    <Card
      onClick={openMatrix}
      className={`_hover mb-0 flex ${fillHeight ? "min-h-0 flex-1" : "h-[180px] shrink-0"} min-w-0 flex-col overflow-hidden [&>.page-loader]:min-h-0 [&>.page-loader]:flex-1 [&>.page-loader>div]:flex [&>.page-loader>div]:min-h-0 [&>.page-loader>div]:flex-1`}
      title={<DashboardCardTitle icon={faHeart} title="Risques psychosociaux" onDetailClick={openMatrix} />}>
      {!hasRisk ? (
        <div className="grey-t flex flex-1 items-center justify-center text-center">Aucune donnée RPS disponible.</div>
      ) : (
        <div
          ref={populationsContainerRef}
          className="flex min-h-0 min-w-0 flex-1 flex-col gap-[10px] overflow-hidden"
          onClick={(event) => event.stopPropagation()}>
          {concernedPopulations.slice(0, availablePopulationCount).map((population) => (
            <div key={population.id} className="flex min-w-0 shrink-0 items-center gap-[16px]" style={{ height: POPULATION_HEIGHT }}>
              <div className="flex min-w-0 flex-1">
                <UnitChip unit={{ type: "population", population }} onClick={() => navigate(getPath(`/populations/${population.id}`))} />
              </div>
              <div className="shrink-0" style={{ width: RPS_GLOBAL_CELL_WIDTH }}>
                <RpsRiskCell level={population.cRpsLevel} isGlobal label={`Niveau de risque, ${population.name}`} />
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  )
}
